import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { msalConfig } from '../services/msal';

const useLoginRedirect = () => {
  const location = useLocation();
  const { instance } = useMsal();

  return useCallback(() => {
    const redirectStartPage = `${location.pathname}${location.search}`;
    instance.loginRedirect({ ...msalConfig.loginRequest, redirectStartPage });
  }, [instance, location]);
};

export default useLoginRedirect;